import ManagementIntractionList from "./managementIntractionList";
export default ManagementIntractionList